import React, { useState, useEffect, useContext } from 'react';

import {
    makeStyles,
    Divider,
    IconButton,
    Menu,
    MenuItem,
    Typography
} from '@material-ui/core';
import {
    api,
    Link,
    IconOpciones,
    PortalContext
} from '@portal/arq-portal-core';
import { useSWRConfig } from 'swr';

const useStyles = makeStyles({
    productoDetalle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '3px 0', 
        color: '#606060',
    },
    productoDetalleIconos: {
        display: 'flex'
    },
    productoDetalleEnlace: {
        display: 'flex',
        alignItems: 'center'
    },
    productoDetalleEnlaceIcono: {
        fontSize: 22,
        color:'#606060',
        '&:hover': {
            color:'#919191',
        }, 
        '&:focus, &:active': {
            color:'#DC0028',
        }, 
    },
    productoDetalleEnlaceOpciones: {
        padding: 5
    },
    productoDetalleEnlaceOpcionesIcono: {
        width: '12px',
        height: '12px'
    }
});

export interface ProductoProps {
    producto: any;
    favs?:any
};

export const DetalleProducto = ({producto}: ProductoProps) => {

    const clases = useStyles();
    const { user } = useContext(PortalContext);
    const [menuCuartoNivel, setMenuCuartoNivel] = useState<any[]>([]);
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const { mutate } = useSWRConfig();

    const manejarClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    }

    const manejarCerrar = () => {
        setAnchorEl(null);
    };

    const manejarEnlaceClick = () => {
        // Esperar un segudo para actualizar lista de Ultimas Visitas
        setTimeout(() => {
            mutate(["ultimasvisitas", user?.id], () => api.getAsync("/be/historial/"), false);
        }, 1000);
    }

    useEffect(() => {
        if (producto?.enlaces) {
            let cuartoNivel: any[] = [];
            producto.enlaces.forEach((enlace: any) => {
                if (enlace?.enlaces?.length > 0) {
                    cuartoNivel = [...cuartoNivel, ...enlace.enlaces];
                }
            });
            cuartoNivel.length > 0 && setMenuCuartoNivel(cuartoNivel);
        }
    }, []);

    return (
        <React.Fragment>
            <div className={clases.productoDetalle}>
                
                {producto.enlaces && producto.enlaces.length > 1 ?
                 <Typography variant='caption' >{producto.titulo}</Typography> :
                <Link to={producto.url} title={producto.titulo} className={clases.productoDetalleEnlace}>
                    <Typography variant='caption' onClick={manejarEnlaceClick}>{producto.titulo}</Typography>
                </Link> 
                }   
                <div className={clases.productoDetalleIconos}>
                    {producto.enlaces && producto.enlaces.map((enlace: any) =>
                        
                        {  return  enlace ? <Link to={enlace.url} title={enlace.titulo} className={clases.productoDetalleEnlace}>
                            <i className={`${enlace.icono} ${clases.productoDetalleEnlaceIcono} Cursor`} onClick={manejarEnlaceClick}></i>
                        </Link> : null }

                    )}
                    {menuCuartoNivel.length > 0 &&
                        <React.Fragment>
                            <IconButton className={clases.productoDetalleEnlaceOpciones} onClick={manejarClick}>
                                <IconOpciones className={clases.productoDetalleEnlaceOpcionesIcono} size='small' />
                            </IconButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={manejarCerrar}
                                MenuListProps={{
                                    'aria-labelledby': 'basic-button',
                                }}
                            >
                                {menuCuartoNivel.map((menu: any) => 
                                    <MenuItem>
                                        <Link to={menu.url}>
                                            <Typography variant='caption' onClick={manejarEnlaceClick}>{menu.titulo}</Typography>
                                        </Link>
                                    </MenuItem>
                                )}
                            </Menu>
                        </React.Fragment>
                    }
                </div>
            </div>
            <Divider />
        </React.Fragment>
    );
};